import React, { useEffect,useState } from 'react'
import './style.css'
import { useNavigate } from "react-router-dom";
import productsIcon from '../../../assets/icons/products.svg';
import BranchDetailsInfoContainer from '../../../components/DashboardComponents/BranchDetailsInfoContainer/BranchDetailsInfoContainer';
import ProfileIntiationLablesContainer from '../../../components/DashboardComponents/ProfileIntiationLablesContainer';
import GetRequest from '../../../service/GetRequest';
import CookieHandler from '../../LandingPage/Authentication/CookieHandler'

const ProductsListPage = ({ setActivePath , header, description, headerActionName, headerActionNavigationLink, isSaveAndContinueRequired, saveButtonNavigationLink}) => {
  const navigate = useNavigate();
  const userId = CookieHandler.getCookie("userid");
  const [BranchList,setBranchList ] = useState([]);
  const [storeName, setStoreName] =useState("");


  
  useEffect(() => {
    setActivePath("Dashboard");
    GetRequest("v1/store-management-service/view/my/store",true)
            .then(response => {
                if (!response || response === undefined) {
                    console.log("No store found for this user");
                } else {
                    console.log(response);
                    setStoreName(response.brandName)
                    setBranchList(response.storeBranches);
                }
            })
            .catch(error => {
                console.error("Error fetching store data:", error);
            });
            
  }, [setActivePath,userId]);


  return (
    <div className="outlet-container">
      <div className="background-white">
        <div className="background-white-sub-container">

        <ProfileIntiationLablesContainer title={header} description={description} status={true} navigation={headerActionNavigationLink} icon={productsIcon} iconBackgroundColor="#59BFF1" actionName={headerActionName} />

     <br/>
     

      {BranchList.length === 0 ? (
            <div>
              <div className="flex justify-center items-center h-screen">
                <div className="text-center">
                  <div className="mb-5">No branches found</div>
                </div>
              </div>
            </div>
          ) : (
            <div className="branch-details-container-padding">
              {BranchList.map((item, index) => (
                <BranchDetailsInfoContainer
                  key={index}
                  branchId={item.id} // Ensure each component has a unique key
                  paddingRequired // Assuming you always want padding
                  actionRequired // Assuming action is always required
                  actionName="Add products"
                  storeName={storeName}
                  postcode={item.postcode}
                  country={item.country}
                  county={item.county}
                  city={item.city}
                  addressLine3={item.addressLine3}
                  addressLine2={item.addressLine2}
                  addressLine1={item.addressLine1}
                  navigationLink="/store/branch/add/product/"
                />
              ))}
            </div>
          )}
     
           {isSaveAndContinueRequired && (
          <div onClick={() => navigate(saveButtonNavigationLink)} className="flex justify-center items-center cursor-pointer px-16 py-4 mt-10 mr-9 max-w-full text-lg font-medium text-white bg-sky-500 rounded-lg w-[379px] max-md:px-5 hover:bg-black hover:text-white transition duration-300 ease-in-out">
          Save and Continue
        </div>
        )}
          </div>
        </div>
        </div>



  )
}

export default ProductsListPage
